import React, { useState } from "react";
import { Link } from "react-router-dom";

const T = "#00c896";
const N = "#0f2040";
const F = "system-ui,sans-serif";

// ── Illustrations ─────────────────────────────────────────────────────────────

const IllustFaceEngine = () => (
  <svg viewBox="0 0 400 260" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="400" height="260" fill={N} rx="14"/>
    {/* Face scan area */}
    <circle cx="200" cy="120" r="80" fill="rgba(0,200,150,0.04)" stroke={T} strokeWidth="1" strokeDasharray="6 4"/>
    <circle cx="200" cy="120" r="60" stroke={T} strokeWidth="0.8" opacity="0.3"/>
    {/* Face silhouette */}
    <ellipse cx="200" cy="110" rx="34" ry="40" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5"/>
    <circle cx="186" cy="100" r="4.5" fill="rgba(255,255,255,0.5)"/>
    <circle cx="214" cy="100" r="4.5" fill="rgba(255,255,255,0.5)"/>
    <path d="M189 122 q11 8 22 0" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round" fill="none"/>
    {/* Scan line */}
    <line x1="120" y1="120" x2="280" y2="120" stroke={T} strokeWidth="1.5" opacity="0.6" strokeDasharray="5 3"/>
    {/* Corner brackets */}
    {([[120,50],[280,50],[120,190],[280,190]] as [number,number][]).map(([cx,cy],i) => (
      <g key={i}>
        <line x1={cx} y1={cy} x2={cx+(i%2===0?14:-14)} y2={cy} stroke={T} strokeWidth="2.5" strokeLinecap="round"/>
        <line x1={cx} y1={cy} x2={cx} y2={cy+(i<2?14:-14)} stroke={T} strokeWidth="2.5" strokeLinecap="round"/>
      </g>
    ))}
    {/* Face landmarks */}
    {[[200,68],[170,88],[230,88],[200,148],[184,130],[216,130],[200,110]].map(([x,y],i) => (
      <circle key={i} cx={x} cy={y} r="2.5" fill={T} opacity="0.5"/>
    ))}
    {/* Liveness badge */}
    <rect x="20" y="20" width="140" height="52" rx="10" fill="rgba(255,255,255,0.04)" stroke="rgba(0,200,150,0.2)" strokeWidth="1"/>
    <circle cx="42" cy="40" r="8" fill="rgba(0,200,150,0.2)"/>
    <path d="M38 40l3 3 5-5" stroke={T} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <text x="56" y="37" fontSize="9" fontWeight="700" fill={T} fontFamily={F}>LIVENESS OK</text>
    <text x="56" y="50" fontSize="7.5" fill="rgba(255,255,255,0.4)" fontFamily={F}>3D Anti-Spoofing</text>
    <rect x="20" y="80" width="140" height="52" rx="10" fill="rgba(255,255,255,0.04)" stroke="rgba(0,200,150,0.2)" strokeWidth="1"/>
    <text x="34" y="100" fontSize="8" fill="rgba(255,255,255,0.4)" fontFamily={F}>Match Score</text>
    <text x="34" y="122" fontSize="24" fontWeight="900" fill={T} fontFamily={F}>99.2%</text>
    {/* Result */}
    <rect x="240" y="20" width="140" height="80" rx="10" fill="rgba(0,200,150,0.08)" stroke="rgba(0,200,150,0.2)" strokeWidth="1"/>
    <text x="310" y="44" fontSize="9" fontWeight="700" fill={T} textAnchor="middle" fontFamily={F}>IDENTITY VERIFIED</text>
    {[["NIK","✓ Valid"],["Face Match","99.2%"],["Liveness","Passed"]].map(([k,v],i) => (
      <g key={i}>
        <text x="254" y={62+i*16} fontSize="7.5" fill="rgba(255,255,255,0.4)" fontFamily={F}>{k}</text>
        <text x="376" y={62+i*16} fontSize="7.5" fontWeight="700" fill={T} textAnchor="end" fontFamily={F}>{v}</text>
      </g>
    ))}
    {/* Response bar */}
    <rect x="20" y="220" width="360" height="28" rx="8" fill="rgba(0,200,150,0.08)" stroke="rgba(0,200,150,0.15)" strokeWidth="1"/>
    <text x="200" y="238" fontSize="8.5" fontWeight="700" fill={T} textAnchor="middle" fontFamily={F}>⚡ Response in 1.8s · 99.97% accuracy · KTP / Passport / SIM supported</text>
  </svg>
);

const IllustWatchlist = () => (
  <svg viewBox="0 0 400 260" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="400" height="260" fill="#0d1f3c" rx="14"/>
    {/* Radar */}
    <circle cx="180" cy="130" r="90" stroke="#f97316" strokeWidth="0.6" opacity="0.2" fill="none"/>
    <circle cx="180" cy="130" r="65" stroke="#f97316" strokeWidth="0.6" opacity="0.3" fill="none"/>
    <circle cx="180" cy="130" r="40" stroke="#f97316" strokeWidth="0.8" opacity="0.45" fill="none"/>
    <circle cx="180" cy="130" r="16" fill="rgba(249,115,22,0.15)" stroke="#f97316" strokeWidth="1.5"/>
    <text x="180" y="134" fontSize="9" fontWeight="700" fill="#f97316" textAnchor="middle" fontFamily={F}>AML</text>
    <path d="M180 130 L180 42 A88 88 0 0 1 258 196 Z" fill={T} opacity="0.05"/>
    {/* Hit nodes */}
    <circle cx="108" cy="72" r="14" fill="rgba(239,68,68,0.15)" stroke="#ef4444" strokeWidth="1.5"/>
    <text x="108" y="76" fontSize="8" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>PEP</text>
    <circle cx="255" cy="82" r="14" fill="rgba(239,68,68,0.15)" stroke="#ef4444" strokeWidth="1.5"/>
    <text x="255" y="86" fontSize="8" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>SDN</text>
    <circle cx="240" cy="196" r="14" fill="rgba(245,158,11,0.15)" stroke="#f59e0b" strokeWidth="1.5"/>
    <text x="240" y="200" fontSize="7" fontWeight="700" fill="#f59e0b" textAnchor="middle" fontFamily={F}>WL</text>
    <line x1="180" y1="130" x2="108" y2="72" stroke="#ef4444" strokeWidth="1" strokeDasharray="4 3" opacity="0.5"/>
    <line x1="180" y1="130" x2="255" y2="82" stroke="#ef4444" strokeWidth="1" strokeDasharray="4 3" opacity="0.5"/>
    <line x1="180" y1="130" x2="240" y2="196" stroke="#f59e0b" strokeWidth="1" strokeDasharray="4 3" opacity="0.4"/>
    {/* Results panel */}
    <rect x="290" y="20" width="96" height="220" rx="10" fill="rgba(255,255,255,0.03)" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
    <text x="338" y="42" fontSize="9" fontWeight="700" fill="rgba(255,255,255,0.7)" textAnchor="middle" fontFamily={F}>Screening</text>
    {[
      { label:"PEP",      val:"2 hits",  color:"#ef4444" },
      { label:"Sanctions",val:"1 hit",   color:"#ef4444" },
      { label:"Neg. Info",val:"Clear",   color:T },
      { label:"Watchlist",val:"Clear",   color:T },
      { label:"OFAC",     val:"Clear",   color:T },
      { label:"OJK",      val:"Clear",   color:T },
    ].map((r,i) => (
      <g key={i}>
        <text x="304" y={64+i*28} fontSize="7" fill="rgba(255,255,255,0.3)" fontFamily={F}>{r.label}</text>
        <text x="304" y={76+i*28} fontSize="9" fontWeight="700" fill={r.color} fontFamily={F}>{r.val}</text>
      </g>
    ))}
    <rect x="300" y="216" width="76" height="16" rx="8" fill="rgba(239,68,68,0.15)"/>
    <text x="338" y="228" fontSize="7.5" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>⚠ REVIEW</text>
    {/* Bottom info */}
    <rect x="20" y="236" width="260" height="14" rx="7" fill="rgba(0,200,150,0.06)" stroke="rgba(0,200,150,0.15)" strokeWidth="1"/>
    <text x="150" y="246" fontSize="7.5" fill={T} textAnchor="middle" fontFamily={F}>200+ global watchlists · Real-time · OJK compliant</text>
  </svg>
);

const IllustBankStatement = () => (
  <svg viewBox="0 0 400 260" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="400" height="260" fill="#0d1f3c" rx="14"/>
    {/* Statement card */}
    <rect x="20" y="16" width="220" height="200" rx="10" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
    <rect x="20" y="16" width="220" height="36" rx="10" fill={N}/>
    <rect x="20" y="44" width="220" height="8" fill={N}/>
    <text x="130" y="36" fontSize="8.5" fontWeight="700" fill="rgba(255,255,255,0.7)" textAnchor="middle" fontFamily={F}>BANK STATEMENT — Mar 2025</text>
    {[
      { d:"01 Mar", desc:"Transfer In",  amt:"+5,000,000", c:T,         fake:false },
      { d:"02 Mar", desc:"Transfer Out", amt:"-2,500,000", c:"#ef4444",  fake:false },
      { d:"05 Mar", desc:"Top Up",       amt:"+1,200,000", c:T,         fake:true  },
      { d:"07 Mar", desc:"Withdrawal",   amt:"-800,000",   c:"#ef4444",  fake:false },
      { d:"10 Mar", desc:"Transfer In",  amt:"+9,999,999", c:T,         fake:true  },
      { d:"14 Mar", desc:"Balance Adj.", amt:"+0",         c:"#f59e0b",  fake:true  },
    ].map((r,i) => (
      <g key={i}>
        <rect x="28" y={62+i*26} width="204" height="22" rx="3" fill={r.fake ? "rgba(239,68,68,0.08)" : (i%2===0?"rgba(255,255,255,0.02)":"transparent")}/>
        {r.fake && <rect x="28" y={62+i*26} width="3" height="22" rx="1.5" fill="#ef4444"/>}
        <text x="36" y={76+i*26} fontSize="7" fill="rgba(255,255,255,0.35)" fontFamily={F}>{r.d}</text>
        <text x="70" y={76+i*26} fontSize="7.5" fill={r.fake?"#ef4444":"rgba(255,255,255,0.6)"} fontFamily={F}>{r.desc}</text>
        <text x="220" y={76+i*26} fontSize="7.5" fontWeight="700" fill={r.fake?"#ef4444":r.c} textAnchor="end" fontFamily={F}>{r.amt}</text>
      </g>
    ))}
    {/* Analysis panel */}
    <rect x="252" y="16" width="132" height="200" rx="10" fill="rgba(255,255,255,0.03)" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
    <text x="318" y="38" fontSize="9" fontWeight="700" fill="rgba(255,255,255,0.7)" textAnchor="middle" fontFamily={F}>Analysis</text>
    {[
      { label:"Authenticity", val:"Fake ⚠",  color:"#ef4444" },
      { label:"Avg Balance",  val:"Rp 3.2M", color:"rgba(255,255,255,0.7)" },
      { label:"Cash Flow",    val:"Volatile", color:"#f59e0b" },
      { label:"Metadata",     val:"Mismatch", color:"#ef4444" },
      { label:"Font Forgery", val:"Detected", color:"#ef4444" },
    ].map((r,i) => (
      <g key={i}>
        <text x="264" y={58+i*30} fontSize="7" fill="rgba(255,255,255,0.3)" fontFamily={F}>{r.label}</text>
        <text x="264" y={72+i*30} fontSize="9" fontWeight="700" fill={r.color} fontFamily={F}>{r.val}</text>
      </g>
    ))}
    <rect x="262" y="190" width="112" height="16" rx="8" fill="rgba(239,68,68,0.15)"/>
    <text x="318" y="201" fontSize="7.5" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>⚠ Fake Detected</text>
    {/* Bottom bar */}
    <rect x="20" y="228" width="364" height="20" rx="8" fill="rgba(0,200,150,0.06)" stroke="rgba(0,200,150,0.15)" strokeWidth="1"/>
    <text x="202" y="241" fontSize="8" fill={T} textAnchor="middle" fontFamily={F}>Deep transaction forensics · Metadata validation · Multi-bank format support</text>
  </svg>
);

const IllustLegalOpinion = () => (
  <svg viewBox="0 0 400 280" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="400" height="280" fill="#120d2a" rx="14"/>
    {/* Document panel */}
    <rect x="18" y="16" width="178" height="228" rx="10" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
    <rect x="18" y="16" width="178" height="32" rx="10" fill="#6366f1" opacity="0.6"/>
    <rect x="18" y="40" width="178" height="8" fill="#6366f1" opacity="0.3"/>
    <text x="107" y="34" fontSize="8" fontWeight="700" fill="white" textAnchor="middle" fontFamily={F}>PERJANJIAN KERJA SAMA</text>
    {/* Doc lines */}
    {[56,70,84,98,112,126,140,154,168,182].map((y,i) => (
      <rect key={i} x="30" y={y} width={i%4===0?146:i%4===1?118:i%4===2?138:98} height="7" rx="2" fill="rgba(255,255,255,0.06)"/>
    ))}
    {/* Risk highlights */}
    <rect x="30" y="112" width="146" height="7" rx="2" fill="rgba(239,68,68,0.2)" stroke="#ef4444" strokeWidth="0.5"/>
    <rect x="30" y="168" width="128" height="7" rx="2" fill="rgba(245,158,11,0.15)" stroke="#f59e0b" strokeWidth="0.5"/>
    {/* Risk flags */}
    <rect x="30" y="200" width="146" height="14" rx="7" fill="rgba(239,68,68,0.1)"/>
    <text x="103" y="210" fontSize="7.5" fontWeight="700" fill="#ef4444" textAnchor="middle" fontFamily={F}>⚠ Liability Clause Found</text>
    <rect x="30" y="218" width="146" height="14" rx="7" fill="rgba(245,158,11,0.08)"/>
    <text x="103" y="228" fontSize="7.5" fontWeight="700" fill="#f59e0b" textAnchor="middle" fontFamily={F}>⚠ Termination Risk</text>
    {/* AI Panel */}
    <rect x="208" y="16" width="176" height="228" rx="10" fill="rgba(255,255,255,0.03)" stroke="rgba(99,102,241,0.25)" strokeWidth="1"/>
    <rect x="208" y="16" width="176" height="34" rx="10" fill="rgba(99,102,241,0.14)"/>
    <rect x="208" y="42" width="176" height="8" fill="rgba(99,102,241,0.06)"/>
    <text x="296" y="36" fontSize="9" fontWeight="700" fill="#a5b4fc" textAnchor="middle" fontFamily={F}>AI Legal Opinion</text>
    {/* 4 rows with comfortable 36px spacing */}
    {[
      { label:"Risk Level",   val:"Medium",      color:"#f59e0b" },
      { label:"Liability",    val:"2 Clauses",   color:"#ef4444" },
      { label:"OJK Align.",   val:"✓ Compliant", color:T },
      { label:"Jurisdiction", val:"Indonesia",   color:"rgba(255,255,255,0.65)" },
    ].map((r,i) => (
      <g key={i}>
        <text x="222" y={68+i*36} fontSize="7.5" fill="rgba(255,255,255,0.35)" fontFamily={F}>{r.label}</text>
        <text x="222" y={84+i*36} fontSize="10" fontWeight="700" fill={r.color} fontFamily={F}>{r.val}</text>
      </g>
    ))}
    {/* Recommendation box — starts after 4×36 = 144 + 68 = 212 */}
    <rect x="218" y="216" width="158" height="22" rx="8" fill="rgba(99,102,241,0.1)" stroke="rgba(99,102,241,0.25)" strokeWidth="1"/>
    <text x="297" y="225" fontSize="7" fill="rgba(255,255,255,0.4)" textAnchor="middle" fontFamily={F}>Recommendation</text>
    <text x="297" y="234" fontSize="8" fontWeight="700" fill="#a5b4fc" textAnchor="middle" fontFamily={F}>Request clause amendment</text>
    {/* Bottom bar */}
    <rect x="18" y="254" width="364" height="16" rx="8" fill="rgba(99,102,241,0.06)"/>
    <text x="200" y="265" fontSize="7.5" fill="#a5b4fc" textAnchor="middle" fontFamily={F}>Generated in 1.4s · OJK / POJK framework · Bahasa Indonesia supported</text>
  </svg>
);

const IllustCreditEngine = () => {
  // Arc center (160, 195), radius 100 — semicircle from 180° to 0°
  // Points at exact 60° boundaries (butt caps → no overlap blobs)
  // 180°→120° red | 120°→60° amber | 60°→0° teal
  // cos/sin(120°) = -0.5 / 0.866  |  cos/sin(60°) = 0.5 / 0.866
  const cx = 155, cy = 195, r = 96, sw = 18;
  const p = (deg: number, rr = r) => ({
    x: +(cx + rr * Math.cos((deg * Math.PI) / 180)).toFixed(1),
    y: +(cy - rr * Math.sin((deg * Math.PI) / 180)).toFixed(1),
  });
  const L = p(180), M1 = p(120), M2 = p(60), R = p(0);
  // Needle points at 28° (good zone)
  const tip = p(28, 72);
  return (
  <svg viewBox="0 0 400 260" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%" }}>
    <rect width="400" height="260" fill={N} rx="14"/>

    {/* Track */}
    <path d={`M${L.x} ${L.y} A${r} ${r} 0 0 1 ${R.x} ${R.y}`} stroke="rgba(255,255,255,0.07)" strokeWidth={sw} fill="none" strokeLinecap="butt"/>

    {/* Colored segments — butt caps so no blobs at joints */}
    <path d={`M${L.x} ${L.y} A${r} ${r} 0 0 1 ${M1.x} ${M1.y}`} stroke="#ef4444" strokeWidth={sw} fill="none" strokeLinecap="butt"/>
    <path d={`M${M1.x} ${M1.y} A${r} ${r} 0 0 1 ${M2.x} ${M2.y}`} stroke="#f59e0b" strokeWidth={sw} fill="none" strokeLinecap="butt"/>
    <path d={`M${M2.x} ${M2.y} A${r} ${r} 0 0 1 ${R.x} ${R.y}`} stroke={T} strokeWidth={sw} fill="none" strokeLinecap="butt"/>

    {/* Round caps only at the two outer ends */}
    <circle cx={L.x} cy={L.y} r={sw/2} fill="#ef4444"/>
    <circle cx={R.x} cy={R.y} r={sw/2} fill={T}/>

    {/* Score */}
    <text x={cx} y={cy-32} fontSize="40" fontWeight="900" fill={T} textAnchor="middle" fontFamily={F}>782</text>
    <text x={cx} y={cy-16} fontSize="10" fill="rgba(255,255,255,0.4)" textAnchor="middle" fontFamily={F}>Credit Score</text>

    {/* Labels */}
    <text x={L.x-2} y={L.y+16} fontSize="8" fill="#ef4444" textAnchor="middle" fontFamily={F}>Poor</text>
    <text x={cx}    y={cy-r-8} fontSize="8" fill="#f59e0b" textAnchor="middle" fontFamily={F}>Fair</text>
    <text x={R.x+2} y={R.y+16} fontSize="8" fill={T}       textAnchor="middle" fontFamily={F}>Good</text>

    {/* Needle */}
    <line x1={cx} y1={cy} x2={tip.x} y2={tip.y} stroke="white" strokeWidth="3" strokeLinecap="round" opacity="0.9"/>
    <circle cx={cx} cy={cy} r="9" fill="rgba(255,255,255,0.1)" stroke="rgba(255,255,255,0.35)" strokeWidth="1.5"/>
    <circle cx={cx} cy={cy} r="4" fill="white"/>

    {/* Data pills — top left */}
    <text x="22" y="28" fontSize="8" fontWeight="700" fill="rgba(255,255,255,0.4)" fontFamily={F}>Data Sources</text>
    {([
      { label:"BI SLIK",  color:"#6366f1", x:22  },
      { label:"PPATK",    color:"#f59e0b", x:88  },
      { label:"Dukcapil", color:"#0ea5e9", x:154 },
      { label:"OJK",      color:T,         x:220 },
    ] as {label:string;color:string;x:number}[]).map(s => (
      <g key={s.label}>
        <rect x={s.x} y={32} width={58} height={16} rx={8} fill={s.color} opacity={0.13} stroke={s.color} strokeWidth={1}/>
        <text x={s.x+29} y={43} fontSize="7" fontWeight="700" fill={s.color} textAnchor="middle" fontFamily={F}>{s.label}</text>
      </g>
    ))}

    {/* Decision panel */}
    <rect x="284" y="16" width="102" height="228" rx="10" fill="rgba(0,200,150,0.05)" stroke="rgba(0,200,150,0.2)" strokeWidth="1"/>
    <text x="335" y="36" fontSize="9" fontWeight="700" fill="rgba(255,255,255,0.55)" textAnchor="middle" fontFamily={F}>Decision</text>
    <rect x="294" y="42" width="82" height="24" rx="8" fill="rgba(0,200,150,0.15)" stroke={T} strokeWidth="1.2"/>
    <text x="335" y="58" fontSize="11" fontWeight="900" fill={T} textAnchor="middle" fontFamily={F}>APPROVED</text>
    <line x1="294" y1="74" x2="376" y2="74" stroke="rgba(255,255,255,0.06)" strokeWidth="1"/>
    {([
      { label:"Limit", val:"Rp 50M"  },
      { label:"Rate",  val:"0.8%/mo" },
      { label:"Tenor", val:"24 mo"   },
      { label:"Time",  val:"< 3s"    },
    ] as {label:string;val:string}[]).map((d,i) => (
      <g key={i}>
        <text x="296" y={92+i*38} fontSize="7.5" fill="rgba(255,255,255,0.3)" fontFamily={F}>{d.label}</text>
        <text x="296" y={107+i*38} fontSize="10" fontWeight="700" fill="rgba(255,255,255,0.75)" fontFamily={F}>{d.val}</text>
      </g>
    ))}

    {/* Bottom bar */}
    <rect x="20" y="238" width="360" height="14" rx="7" fill="rgba(0,200,150,0.06)" stroke="rgba(0,200,150,0.12)" strokeWidth="1"/>
    <text x="200" y="248" fontSize="7.5" fill={T} textAnchor="middle" fontFamily={F}>AI scoring · Multi-source · 24/7 availability · OJK compliant</text>
  </svg>
  );
};

// ── Steps ─────────────────────────────────────────────────────────────────────
const steps = [
  {
    num: "01",
    title: "Face Engine",
    label: "Face Engine",
    desc: "Biometric eKYC with passive liveness detection and 1:1 face matching against KTP, Passport, or SIM. Anti-spoofing, 3D depth, and deepfake detection — all in under 2 seconds.",
    tags: ["99.97% Accuracy", "Passive Liveness", "< 2s Response"],
    illust: <IllustFaceEngine />,
    color: T,
  },
  {
    num: "02",
    title: "Watchlist Screening",
    label: "Watchlist",
    desc: "Screen any individual against 200+ global watchlists — PEP, OFAC, UN Sanctions, OJK, and PPATK. Real-time updates with automated ongoing monitoring for continuous compliance.",
    tags: ["200+ Watchlists", "PEP & Sanctions", "Real-time"],
    illust: <IllustWatchlist />,
    color: "#f97316",
  },
  {
    num: "03",
    title: "Bank Statement Analyzer",
    label: "Bank Statement",
    desc: "Real-time forensics on uploaded bank statements. Detects font tampering, metadata inconsistencies, and suspicious transaction patterns before any credit or onboarding decision.",
    tags: ["Fake Detection", "Metadata Forensics", "Multi-bank"],
    illust: <IllustBankStatement />,
    color: "#ef4444",
  },
  {
    num: "04",
    title: "Legal Opinion",
    label: "Legal Opinion",
    desc: "AI-powered legal analysis of contracts and agreements — structured insights on liability clauses, OJK compliance, and risk flags. Output in Bahasa Indonesia in under 2 seconds.",
    tags: ["< 2s Analysis", "OJK Framework", "Bahasa Indonesia"],
    illust: <IllustLegalOpinion />,
    color: "#6366f1",
  },
  {
    num: "05",
    title: "Credit Approval Engine",
    label: "Credit Engine",
    desc: "AI-driven credit scoring using BI SLIK, PPATK, Dukcapil, and OJK data. Returns an approval decision with limit, rate, and tenor recommendation — anywhere, anytime.",
    tags: ["4+ Data Sources", "AI Scoring", "24/7 Decisions"],
    illust: <IllustCreditEngine />,
    color: "#0ea5e9",
  },
];

// ── Component ─────────────────────────────────────────────────────────────────
const HowItWorks: React.FC = () => {
  const [active, setActive] = useState(0);
  const step = steps[active];

  return (
    <section className="hiw-section" style={{ background: "#ffffff", padding: "100px 0 120px" }}>
      <div className="container">

        {/* Header */}
        <div className="hiw-header" style={{ textAlign: "center", marginBottom: 64 }}>
          <span style={{
            display: "inline-block", padding: "6px 18px", borderRadius: 20, marginBottom: 16,
            background: "rgba(0,200,150,0.1)", border: "1px solid rgba(0,200,150,0.25)",
            fontSize: 13, fontWeight: 700, color: "#00a07a",
          }}>Our Products</span>
          <h2 style={{ fontSize: 38, fontWeight: 800, color: N, marginBottom: 16, lineHeight: 1.2 }}>
            Five products.<br />One platform.
          </h2>
          <p style={{ color: "rgba(15,32,64,0.5)", fontSize: 16, maxWidth: 500, margin: "0 auto" }}>
            From identity verification to credit decisions — TrustEngine covers every touchpoint of your customer journey.
          </p>
        </div>

        {/* Product tabs */}
        <div className="hiw-tabs" style={{ display: "flex", justifyContent: "center", gap: 8, marginBottom: 48, flexWrap: "wrap" }}>
          {steps.map((s, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className="hiw-tab-btn"
              style={{
                padding: "10px 22px", borderRadius: 50, border: "none", cursor: "pointer",
                fontSize: 13, fontWeight: 700, transition: "all 0.2s",
                background: active === i ? N : "rgba(15,32,64,0.06)",
                color: active === i ? "white" : "rgba(15,32,64,0.5)",
                boxShadow: active === i ? "0 4px 16px rgba(15,32,64,0.2)" : "none",
              }}
            >
              <span style={{ color: active === i ? s.color : "rgba(15,32,64,0.3)", marginRight: 7, fontSize: 11 }}>{s.num}</span>
              {s.label}
            </button>
          ))}
        </div>

        {/* Active product content */}
        <div className="hiw-grid" style={{
          display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56,
          alignItems: "center",
        }}>
          {/* Illustration */}
          <div className="hiw-illust" style={{ borderRadius: 16, overflow: "hidden", boxShadow: "0 16px 56px rgba(15,32,64,0.18)" }}>
            {step.illust}
          </div>

          {/* Text */}
          <div className="hiw-text">
            <div style={{
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              width: 52, height: 52, borderRadius: 14, marginBottom: 24,
              background: step.color + "18", border: `1.5px solid ${step.color}40`,
              fontSize: 18, fontWeight: 900, color: step.color,
            }}>
              {step.num}
            </div>
            <h3 style={{ fontSize: 30, fontWeight: 800, color: N, marginBottom: 16 }}>
              {step.title}
            </h3>
            <p style={{ fontSize: 16, color: "rgba(15,32,64,0.6)", lineHeight: 1.8, marginBottom: 28 }}>
              {step.desc}
            </p>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 40 }}>
              {step.tags.map((tag, i) => (
                <span key={i} style={{
                  padding: "6px 16px", borderRadius: 20, fontSize: 12, fontWeight: 700,
                  background: step.color + "12", border: `1px solid ${step.color}30`, color: step.color,
                }}>{tag}</span>
              ))}
            </div>

            {/* Navigation */}
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <button
                onClick={() => setActive(Math.max(0, active - 1))}
                disabled={active === 0}
                style={{
                  width: 40, height: 40, borderRadius: "50%", border: "1.5px solid rgba(15,32,64,0.12)",
                  background: "white", cursor: active === 0 ? "not-allowed" : "pointer",
                  opacity: active === 0 ? 0.3 : 1, fontSize: 16, color: N,
                }}>←</button>
              <div style={{ display: "flex", gap: 6 }}>
                {steps.map((_, i) => (
                  <div key={i} onClick={() => setActive(i)} style={{
                    width: i === active ? 28 : 8, height: 8, borderRadius: 4,
                    background: i === active ? step.color : "rgba(15,32,64,0.12)",
                    cursor: "pointer", transition: "all 0.3s",
                  }}/>
                ))}
              </div>
              <button
                onClick={() => setActive(Math.min(steps.length - 1, active + 1))}
                disabled={active === steps.length - 1}
                style={{
                  width: 40, height: 40, borderRadius: "50%", border: "1.5px solid rgba(15,32,64,0.12)",
                  background: "white", cursor: active === steps.length - 1 ? "not-allowed" : "pointer",
                  opacity: active === steps.length - 1 ? 0.3 : 1, fontSize: 16, color: N,
                }}>→</button>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div style={{ textAlign: "center", marginTop: 72 }}>
          <Link to="/contact" className="thm-btn agency-btn">
            <span className="text">Talk to our team</span>
            <span className="arrow"><span className="arrow-icon">
              {[0,1].map(i => (
                <svg key={i} width="20" height="20" viewBox="0 0 28 28" fill="none">
                  <rect x="5.07" y="19.98" width="20.57" height="2.61" transform="rotate(-40.28 5.07 19.98)" fill="white"/>
                  <rect x="7.97" y="7.24" width="2.61" height="2.61" transform="rotate(-40.28 7.97 7.24)" fill="white"/>
                  <rect x="11.65" y="7.55" width="2.61" height="2.61" transform="rotate(-40.28 11.65 7.55)" fill="white"/>
                  <rect x="15.33" y="7.85" width="2.61" height="2.61" transform="rotate(-40.28 15.33 7.85)" fill="white"/>
                  <rect x="18.71" y="11.84" width="2.61" height="2.61" transform="rotate(-40.28 18.71 11.84)" fill="white"/>
                  <rect x="18.41" y="15.52" width="2.61" height="2.61" transform="rotate(-40.28 18.41 15.52)" fill="white"/>
                  <rect x="18.10" y="19.20" width="2.61" height="2.61" transform="rotate(-40.28 18.10 19.20)" fill="white"/>
                </svg>
              ))}
            </span></span>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default HowItWorks;
